import { Loader } from "@itandi/itandi-bb-ui/Loader";
import { Page as Component } from "~/components/specifics/vendors/settings/profiles/Page";
import { useSessions } from "~/hooks/vendors/useSessions";

export function Page() {
	const { data: session, isLoading } = useSessions().index();

	if (isLoading || !session?.vendorUser) {
		return <Loader />;
	}

	return <Component vendorUser={session.vendorUser} />;
}
